<template>
  <v-dialog v-model="dialog" persistent max-width="600px" :key="fcKey">
    <template v-slot:activator="{ on }">
      <v-icon color="primary" dark v-on="on">filter_list</v-icon>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Customize {{ widgetTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs12>
              <h4>Chart Types</h4>
              <v-radio-group>
                <v-radio on-icon="stacked_line_chart" off-icon="stacked_line_chart" label="Line" value="line">Test</v-radio>
                <v-radio on-icon="stacked_bar_chart" off-icon="stacked_bar_chart" label="Stacked Column" value="stackedColumn">Test</v-radio>
                <v-radio on-icon="view_in_ar" off-icon="view_in_ar" label="3D Stacked Bar" value="stackedBar3D">Test</v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12>
              <h4>Filters</h4>
              <v-layout row wrap>
                <v-flex xs6>
                  <h5>Show report for the last:</h5>
                  <v-radio-group row v-model="options.timeframe.selected">
                    <v-radio v-for="option in options.timeframe.options" :key="option.value" :label="option.label" :value="option.value"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs6>
                  <h5>Unit of Time:</h5>
                  <v-radio-group row v-model="options.timeunit.selected">
                    <v-radio v-for="option in options.timeunit.options" :key="option.value" :label="option.label" :value="option.value"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs6>
                  <h5>Departments</h5>
                  <v-autocomplete
                    v-model="options.departments.selected"
                    :items="options.departments.options"
                    label="Filter Departments"
                    item-text="label"
                    item-value="value"
                    chips
                    multiple
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <h5>Regions</h5>
                  <v-autocomplete
                    v-model="options.regions.selected"
                    :items="options.regions.options"
                    label="Filter Regions"
                    item-text="label"
                    item-value="value"
                    chips
                    multiple
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <h5>Status</h5>
                  <v-autocomplete
                    v-model="options.statuses.selected"
                    :items="options.statuses.options"
                    label="Filter Statuses"
                    item-text="label"
                    item-value="value"
                    chips
                    multiple
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <h5>Reps</h5>
                  <v-autocomplete
                    v-model="options.reps.selected"
                    :items="options.reps.options"
                    label="Filter Reps"
                    item-text="label"
                    item-value="value"
                    chips
                    multiple
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>
        <v-btn color="blue darken-1" flat @click="dialog = false">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'dialog-filter-config',
  data: () => ({
    dialog: false,
    options: {
      departments: {
        selected: '',
        options: [
          {
            label: 'Blinds',
            value: 'blinds'
          },
          {
            label: 'Boards',
            value: 'boards'
          },
          {
            label: 'Ceilings',
            value: 'ceilings'
          },
          {
            label: 'Flooring',
            value: 'flooring'
          },
          {
            label: 'Paint',
            value: 'paint'
          },
        ]
      },
      regions: {
        selected: '',
        options: [
          {
            label: 'Western Cape',
            value: 'western_cape'
          },
          {
            label: 'Eastern Cape',
            value: 'eastern_cape'
          },
          {
            label: 'Gauteng',
            value: 'gauteng'
          },
          {
            label: 'KZN',
            value: 'kzn'
          },
          {
            label: 'North West',
            value: 'north_west'
          },
        ]
      },
      statuses: {
        selected: '',
        options: []
      },
      reps: {
        selected: '',
        options: []
      },
      timeframe: {
        selected: 'custom',
        options: [
          {
            label: '7 days',
            value: 'days_7'
          },
          {
            label: '30 days',
            value: 'days_30'
          },
          {
            label: '90 days',
            value: 'days_90'
          },
          {
            label: 'Custom',
            value: 'custom'
          }
        ]
      },
      timeunit: {
        selected: 'per_month',
        options: [
          {
            label: 'Per Month',
            value: 'per_month'
          },
          {
            label: 'Per Quarter',
            value: 'per_quarter'
          },
          {
            label: 'Per 6 Months',
            value: 'per_6_months'
          },
          {
            label: 'Per Year',
            value: 'per_year'
          }
        ]
      }
    }
  }),
  props: ['fcKey', 'widgetTitle']
}
</script>
